$(document).ready(function(){
    var $hero_video = $('.hero__media-container');
    var $promo_videos = $('.background-media-text__video');
    if ($promo_videos.length > 0) {
        $promo_videos.each(function(index){
            var $this = $(this);
            var $video = null;
            var $play_button = $this.closest('.promo-grid__container').find('.video-trigger-button');
            var video_type = $this.data('video-type');
            var section_id = $this.data('section-id');
            var video_id = $this.data('video-id');
            var $promo_video = $this.closest('.promo-video');
            var $mute_button = $this.closest('.promo-grid__container').find('.video-mute');
            var is_play = false;
            if (video_type != 'mp4') {
                $play_button.click(function(){
                    if (is_play) {
                        is_play = false;
                        $this.empty();
                        $promo_video.removeClass('loaded');
                    } else {
                        is_play = true;
                        var new_video = '';
                        $promo_video.addClass('loaded');
                        if (video_type == 'youtube') {
                            new_video = `<iframe id="YouTubeVideo-${section_id}" data-type="youtube" data-video-id="${video_id}" src="https://www.youtube.com/embed/${video_id}?enablejsapi=1&autoplay=1" class="video-div" allow="autoplay; encrypted-media" allowfullscreen title=""></iframe>`;
                        } else if (video_type == 'youtube') {
                            new_video = `<iframe id="YouTubeVideo-${section_id}" data-type="youtube" data-video-id="${video_id}" src="https://player.vimeo.com/video/${video_id}?autoplay=1" class="video-div" allow="autoplay; encrypted-media" allowfullscreen title=""></iframe>`;
                        }
                        $video = $(new_video);
                        $this.append($video);
                    }
                });
            } else {
                var new_video = `<video width="auto" height="auto" loop muted playsinline autoplay>
                    <source src="${video_id}" type="video/mp4">
                </video>`;
                $video = $(new_video);
                $this.append($video);
                $video.prop('muted', false);
                $video.trigger('pause');
                $promo_video.addClass('loaded');
                $play_button.click(function(){
                    if (is_play) {
                        is_play = false;
                        $video.trigger('pause');
                    } else {
                        is_play = true;
                        $video.trigger('play');
                    }
                });
                $mute_button.click(function(){
                    if ($video.prop('muted')) {
                        $video.prop('muted', false);
                        $(this).find('.icon-unmute').css({'display': 'block'});
                        $(this).find('.icon-mute').css({'display': 'none'});
                    } else {
                        $video.prop('muted', true);                        
                        $(this).find('.icon-mute').css({'display': 'block'});
                        $(this).find('.icon-unmute').css({'display': 'none'});
                    }
                });
            }
        });
    }
    if ($hero_video.length > 0) {
        $hero_video.each(function(index){
            var $this = $(this);
            var $video = null;
            var video_type = $this.data('video-type');
            var section_id = $this.data('section-id');
            var video_id = $this.data('video-id');
            var $mute_button = $this.closest('.video-parent-section').find('.video-mute');
            switch (video_type) {
                case 'youtube':
                    new_video = `<iframe id="YouTubeVideo-${section_id}" data-type="youtube" data-video-id="${video_id}" src="https://www.youtube.com/embed/${video_id}?enablejsapi=1&autoplay=1" class="video-div" allow="autoplay; encrypted-media" allowfullscreen title=""></iframe>`;
                    break;
                case 'vimeo':
                    new_video = `<iframe id="YouTubeVideo-${section_id}" data-type="youtube" data-video-id="${video_id}" src="https://player.vimeo.com/video/${video_id}?autoplay=1" class="video-div" allow="autoplay; encrypted-media" allowfullscreen title=""></iframe>`;
                    break;
                case 'mp4':
                    var new_video = `<video width="auto" height="auto" playsinline autoplay muted loop><source src="${video_id}" type="video/mp4"></video>`;
                default:
                    break;
            }
            $video = $(new_video);
            $this.append($video);
            if (video_type == 'mp4') {
                $mute_button.click(function(){
                    if ($video.prop('muted')) {
                        $video.prop('muted', false);
                        $(this).find('.icon-unmute').css({'display': 'block'});
                        $(this).find('.icon-mute').css({'display': 'none'});
                    } else {
                        $video.prop('muted', true);                        
                        $(this).find('.icon-mute').css({'display': 'block'});
                        $(this).find('.icon-unmute').css({'display': 'none'});
                    }
                });
            }
        });
    }
  
  // When product added to cart, remove it from recommended products
  document.addEventListener('ajaxProduct:added', function(ev) {
    var prodID = ev?.detail?.product?.product_id;
    if(prodID) {
      if($('.drawer__scrollable .related-products div[data-product-id="' + prodID + '"]').length) {
        jQuery('#CartDrawer .related-products').addClass('related-products--hidden')
      }
    }
  })

  /** Gift wrap */
  // We add/remove data attribute to cart form
    $(document).on('change', 'input[name="gift_wrap"]', function() {
      var form = $(this).closest('.product-single__meta').find('form[action="/cart/add"]');
      var colorSelect = $(this).closest('.gift_wrap').find('.gift_wrap_color');
      var giftWrapWhiteID = $(this).attr('data-gif-wrap-white')

      if(this.checked) {
        colorSelect.show();
        form.attr('data-gift-wrap', 'true')
        form.attr('data-gift-wrap-id', giftWrapWhiteID)
        form.append(`<input type="hidden" name="properties[gwID]" value="${giftWrapWhiteID}" />`)
      } else {
        colorSelect.hide();
        form.removeAttr('data-gift-wrap')
        form.removeAttr('data-gift-wrap-id')
        form.find('input[name="properties[gwID]"]').remove()
      }
    });
    // On color select append attr to form. Default value is white variant ID
    $(document).on('change', 'select[name="gift_wrap_color"]', function() {
      var form = $(this).closest('.product-single__meta').find('form[action="/cart/add"]');
      form.attr('data-gift-wrap-id', this.value)
      form.find('input[name="properties[gwID]"]').val(this.value)
    });
    // On ATC submit we check for GW product and add it if not there and checkbox selected
    $(document).on('submit', '.product-single__form', function() {
      var values = $(this).serializeArray();
      var qty = values.find(el => el.name == 'quantity' )
      var productID = values.find(el => el.name == 'id' )
      qty = typeof qty.value !== 'undefined' && qty.value > 0 ? qty.value : 1;
      productID = typeof productID.value !== 'undefined' && productID.value > 0 ? productID.value : false;
      var isGiftWrap = $(this).attr('data-gift-wrap');
      var giftWrapWhiteID = $(this).attr('data-gift-wrap-id');
      var giftWrapID = $(this).attr('data-gift-wrap-id');
      if(isGiftWrap === 'true' && typeof giftWrapWhiteID !== 'undefined') {
        var whiteProdId = giftWrapWhiteID;
        var prodID = whiteProdId;
        var headers = new Headers({ 'Content-Type': 'application/json' });
        var hasGift = false;

        if(typeof giftWrapID !== 'undefined' ) {
          prodID = giftWrapID;
        }

        setTimeout(function(){
          
        fetch(window.theme.routes.cart, {
          method: 'GET',
          headers: headers,
        })
        .then(response => response.json())
        .then(function(data) {
          hasGift = data.items.filter(function(item) {
            return item.id == whiteProdId
          });
          products = false;
          if(productID) {
            products = data.items.filter(function(item) {
              return item.id == productID
            });
          }
          productQty = qty;
          if(products && products.length > 0) {
            products.forEach(item => {
              if (typeof item.properties.gwID !== 'undefined' && item.properties.gwID) {
                productQty = item.quantity
              }
            });
          }
          if(!hasGift || hasGift.length <= 0) {
              fetch(window.theme.routes.cartAdd, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ id: prodID, quantity : productQty })
              })
              .then(function() {
                document.dispatchEvent(new CustomEvent('cart:build'));
              });

          } else {
              fetch(window.theme.routes.cartChange, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ id: prodID, quantity : productQty })
              }).then(function() {
                document.dispatchEvent(new CustomEvent('cart:build'));
              });
          }
        });

      }, 200);
      }
    })
  
  // cart:quantity.cart-page
  // cart:quantity.cart-undefined
  function updateGwpQty(ev) {
    var headers = new Headers({ 'Content-Type': 'application/json' }); 
    if(typeof ev.detail[1] !== 'undefined') {
      fetch(window.theme.routes.cart, {
        method: 'GET',
        headers: headers,
      })
      .then(response => response.json())
      .then(function(data) {
        if(data.items.length > 0) {
          hasGift = data.items.filter(function(item) {
            return ((item.key == ev.detail[0]) && (item.properties && typeof item.properties['gwID'] !== 'undefined'))
          });
          if(hasGift.length > 0) {
            setTimeout(function() {
              fetch(window.theme.routes.cartChange, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ id: hasGift[0].properties['gwID'], quantity : ev.detail[1] })
              })
              .then(function() {
                document.dispatchEvent(new CustomEvent('cart:updated'));
                document.dispatchEvent(new CustomEvent('cart:build'));
              });
            }, 500);
          }
        }
      })
    }
  }
  // remove Gift wrap when cart Qty goes to zero
  document.addEventListener('cart:quantity.cart-undefined', function(ev) {
    updateGwpQty(ev)
  });
  document.addEventListener('cart:quantity.cart-page', function(ev) {
    updateGwpQty(ev)
  });

  // remove GW product when product is removed from cart
  $('a[data-gw-id-attached]').on('click', function(e) {
    e.preventDefault();
    var gwId = $(this).attr('data-gw-id-attached')
    prodId = $(this).attr('data-remove-key');
    var headers = new Headers({ 'Content-Type': 'application/json' });    
    if(typeof gwId !== 'undefined' && typeof prodId !== 'undefined') {

      fetch(window.theme.routes.cartChange, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ id: prodId, quantity : 0 })
      })
      .then(function() {
        fetch(window.theme.routes.cartChange, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ id: gwId, quantity : 0 })
        }).then(function() {
          if(document.getElementsByClassName('template-cart').length > 0) {
            location.reload();
          } else {
            document.dispatchEvent(new CustomEvent('cart:build'));
          }

        })
      });
    }
  });
  /** EOF Gift wrap */
});

$(document).on('click', '.collapsible-trigger', function(){
    var $this = $(this);
    var filterCount = $(this).next().find('li').length;
    $(this).next().find('li').each(function(index){
        if (filterCount - 1 == index) {
            $(this).find('label').click();
        } else {
            if ($this.find('input').prop('checked')) {
                $(this).find('input').prop('checked', false);
            } else {
                $(this).find('input').prop('checked', true);
            }
        }        
    });
});

var free_shipping = $('.product-free-shipping').data('free-shipping');
var product_price = $('.product-free-shipping').data('product-compare-price');

function comparePrice() {
    if ($('.data-variant-price').length > 0) {
        if($('.data-variant-price:checked').data('price') > free_shipping) {
            $('.product-free-shipping').show();
        } else {
            $('.product-free-shipping').hide();
        }
    } else {
        if(product_price >= free_shipping) {
            $('.product-free-shipping').show();
        } else {
            $('.product-free-shipping').hide();
        }
    }
}

comparePrice();

$(document).on('change', '.data-variant-price', function(){
    comparePrice();
});

$(document).on('click', '.language-trigger', function(){
    $('.language-list').toggleClass('active');
    $('html').toggleClass('blocked-scroll');
});

$(document).on('click', '.language-list--item a', function(){
    $('.language-list').removeClass('active');
    $('html').removeClass('blocked-scroll');
});

function getPlatform() {
    var platform = ["Android", "iOS", "iPhone"];
 
    for (var i = 0; i < platform.length; i++) {
 
        if (navigator.platform.indexOf(platform[i]) >- 1) {
            if(platform[i] == 'iOS' || platform[i] == 'iPhone') {
                $('body').addClass('IOS');
            }
            return platform[i];
        }
    }
 }
 
 getPlatform();

 
// Deselect Gift wrap when quick view opends
document.addEventListener('quickview:open', function(ev) {
   document.querySelectorAll('.gift_wrap_checkbox').forEach(el => {
    if(el.checked == true) {
      el.click();
    }
   });
});

// Cart drawer related products
document.addEventListener('drawerOpen.CartDrawer', function(e) {
  var elem = document.querySelector('.related-products__items');
  if(elem && !elem.classList.contains('flickity-enabled')) {   
    setTimeout(function() {
      var flkty = new Flickity( elem, {
        // options
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        lazyLoad: false
      });
    }, 700)
  } else {
    showRelatedProducts();

    if (!jQuery('#CartDrawer .related-products').hasClass('related-products--hidden')) {
      var flkty = Flickity.data(elem);
      jQuery('#CartDrawer .related-products').removeClass('related-products--hidden')
      if(flkty){
         flkty.destroy();
          setTimeout(function() {
            var flkty = new Flickity( elem, {
              // options
              contain: true,
              prevNextButtons: false,
              pageDots: false,
              imagesLoaded: true,
              lazyLoad: false
            });
          }, 700);       
      }      
    }
  }
});

document.addEventListener('cart:updated', function(e) {
  showRelatedProducts();
  setTimeout(function() {
    removeUpsellSample();
  }, 200);
});

function showRelatedProducts() {
  var relatedProducts = jQuery('#CartDrawer').attr('data-related-products');
  var isRelatedSectionHidden =  false;
  if(relatedProducts) {
    relatedProducts = relatedProducts.split(',');
    setTimeout(function() {
      jQuery('.drawer__inner .cart__item').each(function(index) {
        var prodHandle = jQuery(this).attr('data-handle');
        if(relatedProducts.length > 0) {
          relatedProducts.forEach(el => {
            if(el == prodHandle) {
              isRelatedSectionHidden = true;
            }
          });
        }
      });
      if(isRelatedSectionHidden == true) {
        jQuery('#CartDrawer .related-products').addClass('related-products--hidden')
      } else {
        jQuery('#CartDrawer .related-products').removeClass('related-products--hidden')
      }
    }, 400);
  }
}

// Clear cart if upsell is the only product in cart
function removeUpsellSample() {
  var headers = new Headers({ 'Content-Type': 'application/json' }); 
  if(typeof window.theme.settings.relatedProductsHandles !== 'undefined' && window.theme.settings.relatedProductsHandles) {
    var handles = window.theme.settings.relatedProductsHandles.split(',');
    if(handles.length > 0 ) {
      fetch(window.theme.routes.cart, {
        method: 'GET',
        headers: headers,
      })
      .then(response => response.json())
      .then(function(data) {
        if(data.items.length == 1) {
          hasUpsell = data.items.filter(function(item) {
            return handles.includes(item.handle)
          });
          if(hasUpsell.length > 0) {
            setTimeout(function() {
              fetch( '/cart/clear.js', {
                method: 'POST',
                headers: headers,
              })
              .then(function() {
                if(document.getElementsByClassName('template-cart').length > 0) {
                  location.reload();
                } else {
                  document.dispatchEvent(new CustomEvent('cart:build'));
                }
              });
            }, 200);
          }
        }
      });
    }
    
  }
}

if(document.getElementsByClassName('template-cart').length > 0) {
  removeUpsellSample();
}
